<template>
  <div class="calendar-header">
    <div class="calendar-header__change">
      <span
        v-show="panel.calendar || panel.year"
        class="calendar-header__change__box"
      >
        <button
          type="button"
          class="calendar-header__change__btn-arrow"
          @click="calendar.onPrevious()"
        >
          <svg
            class="calendar-header__change__svg"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              :d="panel.calendar
                ? `M15 19l-7-7 7-7`
                : `M11 19l-7-7 7-7m8 14l-7-7 7-7`
                "
            ></path>
          </svg>
        </button>
      </span>
    </div>
    <div class="calendar-header__decade">
      <span class="calendar-header__decade__box">
        {{ calendar.month }} {{ calendar.year }}
      </span>
    </div>
    <div class="calendar-header__change">
      <span
        v-show="panel.calendar || panel.year"
        class="calendar-header__change__box"
      >
        <button
          type="button"
          class="calendar-header__change__btn-arrow"
          @click="calendar.onNext()"
        >
          <svg
            class="calendar-header__change__svg"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              :d="panel.calendar ? `M9 5l7 7-7 7` : `M13 5l7 7-7 7M5 5l7 7-7 7`"
            ></path>
          </svg>
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    asPrevOrNext: Boolean,
    panel: Object,
    calendar: Object
  },
  inheritAttrs: false
});
</script>
<style scoped lang="scss">
.calendar-header {
  display: flex;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.375rem;
  border-width: 1px;

  &__change {
    flex-shrink: 0;

    &__box {
      display: inline-flex;
    }

    &__btn-arrow {
      border-width: 0;
      border-color: transparent;
      color: #ffffff;
      background-color: transparent;
      transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration: 300ms;

      :hover {
        cursor: pointer;
      }
    }

    &__svg {
      width: 1.8rem;
      height: 1.8rem;
    }
  }

  &__decade {
    display: flex;
    padding-left: 0.375rem;
    padding-right: 0.375rem;
    margin-left: 0.375rem;
    text-align: center;
    font-size: 1.6rem;
    font-weight: normal;

    &__box {
      display: flex;
      flex: 1 1 0%;
      border-radius: 0.375rem;
    }


  }
}
</style>